import { THEME_ACTIONS } from "../actions/theme-actions";
import { handleActions } from "../utils/redux-helper";
import { configurationActions } from "../actions/configuration-actions";

const initialState = {
  theme: "bootstrap-v5",
  skin: "light",
};

const themeReducer = handleActions(
  {
    [THEME_ACTIONS.SET_THEME]: (state, action) => {
      return {
        ...state,
        theme: action.theme,
      };
    },
    [THEME_ACTIONS.SET_SKIN]: (state, action) => {
      return {
        ...state,
        skin: action.skin,
      };
    },
    [configurationActions.MAIN_CONFIGURATION]: (state, action) => {
      const { theme, skin } = action;

      return {
        ...state,
        theme: theme || state.theme,
        skin: skin || state.skin,
      };
    },
  },
  {
    ...initialState,
  }
);
export default themeReducer;
